import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=60faea6e&scoped=true&"
import script from "./UpdatePassword.vue?vue&type=script&lang=ts&"
export * from "./UpdatePassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60faea6e",
  null
  
)

export default component.exports